import { Component } from '@angular/core';

@Component({
  selector: 'axis-navbar',
  templateUrl: './navbar.component.html',
  host: {
    class: 'axis-navbar-header'
  }
})
export class NavbarComponent {
  // @HostBinding('class.axis-navbar-header') axisNavbarHeader = true;
}

@Component({
  selector: 'axis-navbar-logo',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-navbar-logo'
  }
})
export class NavBarLogoComponent {
  // @HostBinding('class.axis-navbar-logo') axisNavbarLogo = true;
}

@Component({
  selector: 'axis-navbar-app-title',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-navbar-app-title'
  }
})
export class NavBarAppTitleComponent {
  // @HostBinding('class.axis-navbar-app-title') axisNavbarAppTitle = true;
}

@Component({
  selector: 'axis-navbar-sub-title',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-navbar-sub-title'
  }
})
export class NavBarSubTitleComponent {
  // @HostBinding('class.axis-navbar-sub-title') axisNavbarSubtitle = true;
}

@Component({
  selector: 'axis-navbar-right',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-navbar-right'
  }
}) export class NavBarAppRightComponent {
  // @HostBinding('class.axis-navbar-right') axisNavbarRight = true;
}

@Component({
  selector: 'axis-navbar-left',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-navbar-left'
  }
})
export class NavBarAppLeftComponent {
  // @HostBinding('class.axis-navbar-left') axisNavbarLeft = true;
}

// Subnavbar
@Component({
  selector: 'axis-sub-navbar',
  templateUrl: './subnavbar.component.html',
  host: {
    class: 'axis-sub-navbar-wrapper'
  }
})
export class SubNavbarComponent {
  // @HostBinding('class.axis-sub-navbar-wrapper') axisSubnavbarWrapper = true;
}

@Component({
  selector: 'axis-sub-navbar-left',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-sub-navbar-left'
  }
})
export class SubNavbarLeftComponent {
  // @HostBinding('class.axis-sub-navbar-left') axisSubnavbarLeft = true;
}

@Component({
  selector: 'axis-sub-navbar-right',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-sub-navbar-right'
  }
})
export class SubNavbarRightComponent {
  // @HostBinding('class.axis-sub-navbar-right') axisSubnavbarRight = true;
}
